export default __webpack_public_path__ + "img/e820c4d305b0a8b47e187a110c87a246.svg";